// ... Default Options
const DEFAULT_OPTIONS = {
    // debug: import.meta.env.DEV,
    // rowHeight: 30,
    scrollbarWidth: 0,
    suppressHeaderFocus: true,
    suppressScrollOnNewData: true,
    cellSelection: true,
    groupDefaultExpanded: 1,
    enableCellEditingOnBackspace: true,
    defaultColDef: {
        singleClickEdit: false,
        resizable: true,
        sortable: true,
        filter: true,
        suppressHeaderMenuButton: true,
        enableCellChangeFlash: true,
        // suppress AG Grid's native handling
        suppressKeyboardEvent(params) {
            const key = params.event.key;
            const isDeleteKey = key === 'Backspace' || key === 'Delete';
            if (!isDeleteKey)
                return false;
            return true;
        },
    },
    autoSizeStrategy: { type: 'fitCellContents' },
    statusBar: {
        statusPanels: [
            { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
            { statusPanel: 'agSelectedRowCountComponent', align: 'left' },
            { statusPanel: 'agAggregationComponent', align: 'right' },
        ],
    },
    tooltipShowDelay: 500,
    tooltipInteraction: true,
    undoRedoCellEditing: true,
    undoRedoCellEditingLimit: 20,
    domLayout: 'autoHeight',
};
export default DEFAULT_OPTIONS;
